import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField, getSelectField } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import {
  SERVICE_MAX_LENGTH_CODE,
  SERVICE_MAX_LENGTH_NAME,
  RISK_INDICATORS
} from '../../libraries/constants';
import { maximumSubString } from '../../libraries/utils';

const ServiceForm = props => {
  const {
    values,
    classes,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    title
  } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `code`,
              label: `Código`,
              required: true,
              changeHandler: maximumSubString(SERVICE_MAX_LENGTH_CODE),
              formControlClass: classes.fullWidth
            })}
            {getInputField({
              ...fieldProps,
              name: `name`,
              label: 'Nombre',
              required: true,
              changeHandler: maximumSubString(SERVICE_MAX_LENGTH_NAME),
              formControlClass: classes.fullWidth
            })}
            {getSelectField({
              ...props,
              name: 'riskIndicator',
              label: 'Indicador de Riesgo *',
              required: true,
              isClearable: false,
              optionLabel: option => option.name,
              optionValue: option => option.value,
              onMenuClose: () => {
                setFieldTouched('riskIndicator');
              },

              options: RISK_INDICATORS,
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

ServiceForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ServiceForm);
